import React, {useContext, useEffect} from "react";
import Container from "../../components/Container";
import Text from "../../styles/Text";
import {Content} from "../../styles/GlobalStyles";
import {MainContent, ContentImg, LinkCarousel, TitleAca, RowAca, ColAca, SubtitleAca, TextAca} from "./components/AcademyStyles";
import MapAcademy from "./components/MapAcademy";
import MultiCards from "./components/MultiCards";
import Bienvenida from "./components/Bienvenida";
import Programas from "./components/Programas";
import {AcademyContext} from "../../context/DomecqContext";
import {LoadComponet} from "../../components/loaders/Loader";
import {isMobile} from "../../constants/Helpers";
import VideoModal from "../modals/VideoModal";
import {HeadersContext} from "../../context/HeadersContext";
import parse from "html-react-parser";
import useSetTitle from "../../hooks/useSetTitle";

export default function DomecqAcademy() {
   useSetTitle("");
   const {academyList, isLoading} = useContext(AcademyContext);
   const {getHeader, academyHeader} = useContext(HeadersContext);

   useEffect(() => {
      getHeader("Academy");
   }, []);

   if (isLoading.list) return <LoadComponet isVisible={true} />;
   return (
      <Container>
         <>
            <ContentImg
               style={{
                  backgroundImage: `url(http://domecqapi.trebolbit.com/${
                     isMobile ? academyHeader.pathImageWebMobile : academyHeader.pathImageWebDesktop
                  })`,
               }}
            >
               <Content>
                  <div className="contentSlide">
                     {/*  <Text color="white" className="title">
                        Te invitamos a conocer <br />
                        Domecq Academy
                     </Text> */}
                     <Text color="white" className="title">
                        {academyHeader.description ? parse(academyHeader.description) : ""}
                     </Text>
                     <LinkCarousel to="/domecq_academy?showVideo=true">
                        <Text className="text">Ver video</Text>
                        <img src={require("../../assets/icons/media.png")} alt="arrow" width="25px" height="25px" className="imgTo" />
                     </LinkCarousel>
                  </div>
               </Content>
            </ContentImg>
            <Content>
               <MainContent>
                  <TitleAca>
                     El lugar de la experiencia, <br /> pasión y conocimiento.
                  </TitleAca>
                  <RowAca>
                     <ColAca dCol={5} mCol={12}>
                        <SubtitleAca>Misión</SubtitleAca>
                        <TextAca>
                           Ser un referente de formación en el mundo de vinos y bebidas espirituosas para conectar con nuestros clientes y
                           consumidores a través de nuestras marcas y experiencia.
                        </TextAca>
                        <SubtitleAca>Visión</SubtitleAca>
                        <TextAca>
                           Ser reconocida entre nuestros clientes y consumidores por el valor agregado; el diseño de nuestros programas de
                           capacitación y la experiencia de aprendizaje.
                        </TextAca>
                     </ColAca>
                     <ColAca dCol={1} mCol={0} />
                     <ColAca dCol={5} mCol={12}>
                        <SubtitleAca>Atributos</SubtitleAca>
                        <RowAca>
                           <ColAca dCol={6} mCol={6} className="flex">
                              <img src={require("../../assets/icons/acerca/conocimiento_icon.png")} className="attrImg" alt="icon" />
                              <TextAca>Conocimiento</TextAca>
                           </ColAca>
                           <ColAca dCol={6} mCol={6} className="flex">
                              <img src={require("../../assets/icons/acerca/apertura_icon.png")} className="attrImg" alt="icon" />
                              <TextAca>Apertura</TextAca>
                           </ColAca>
                           <ColAca dCol={6} mCol={6} className="flex">
                              <img src={require("../../assets/icons/acerca/cercania_icon.png")} className="attrImg" alt="icon" />
                              <TextAca>Cercania</TextAca>
                           </ColAca>
                           <ColAca dCol={6} mCol={6} className="flex">
                              <img src={require("../../assets/icons/acerca/profesionalismo_icon.png")} className="attrImg" alt="icon" />
                              <TextAca>Profesionalismo</TextAca>
                           </ColAca>
                           <ColAca dCol={6} mCol={6} className="flex">
                              <img src={require("../../assets/icons/acerca/pasion_icon.png")} className="attrImg" alt="icon" />
                              <TextAca>Pasión</TextAca>
                           </ColAca>
                        </RowAca>
                     </ColAca>
                  </RowAca>
               </MainContent>
            </Content>
            <span id="bienvenida" />
            <Bienvenida data={academyList[0]} />
            <span id="formacion" />
            <Programas data={academyList[1]} />

            <MultiCards dataF={academyList[2]} dataI={academyList[3]} />
            <MapAcademy />

            <VideoModal videoUrl={academyHeader.pathVideo} initiator="showVideo" />
         </>
      </Container>
   );
}

/* 

<BasicView imageBack={}>
         <HeadsVies
            icon={require("../../assets/icons/esencial.png")}
            title={
               <span>
                  Cursos <br /> esenciales Domecq
               </span>
            }
            description="Estos cursos estan diseñados para aquellos que van iniciando su carrera o son aficionados. Personal de servicio y barra de 0 a 3 años de experiencia o con estudios afines, que deseen aprender fundamentos, origen y básicos del servicio y los productos de contenido alcoholico"
         />
      </BasicView>
*/
